import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';
@Component({
  selector: 'app-productdisclosure',
  templateUrl: './productdisclosure.component.html',
  styleUrls: ['./productdisclosure.component.css']
})
export class ProductdisclosureComponent implements OnInit {
  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) { 
    this.title.setTitle("Product Disclosure Statement | SingX");
    this.canonicalService.updateauCanonicalUrl('/productdisclosure');
    this.meta.updateTag({ name: 'description', content: 'Singx Australia is a member of Australian Financial Complaints Authority. So transfer your Funds from Australia to any other Country with us.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'International Money Transfer from Australia, Money Transfer Overseas, Global Money Transfer, International Fund Transfer, International Remittance, Remit Money Overseas, Foreign Remittance, International Payment Transfer.' })  
  }

  ngOnInit(): void {
  }

}
